import css from 'src/components/empty-placeholder/empty-placeholder.module.scss';

export default function EmptyPlaceholder() {
  return (
    <div className={css.placeholder}>
      <p className={css.title}>За Вашим запитом поки немає курсів</p>
      <p className={css.recommendation}>Скористайтесь простими рекомендаціями:</p>
      <ul>
        <li>Перевірте правильність написання запиту</li>
        <li>Спробуйте використати більш загальний запит</li>
        <li>Спробуйте знайти інший курс</li>
      </ul>
    </div>
  );
}
